"use client";
import { useEffect, useState } from "react";
import Convert from "unit-converter-pro";
import convert from "convert-units";
import { HowToUseText } from "@/common/ToolPara";
import { usePathname } from "@/i18n/navigation";
import { ParaData } from "../CommonArray/FileArray";

const unitConversionRouteConfig = {
  "/length-convertor": {
    toolName: "Length Converter",
    paraData: ParaData.LENGTH_CONVERTOR,
  },
  "/temprature-convertor": {
    toolName: "Temperature Converter",
    paraData: ParaData.TEMPRATURE_CONVERTOR,
  },
  "/area-convertor": {
    toolName: "Area Converter",
    paraData: ParaData.AREA_CONVERTOR,
  },
  "/pressure-convertor": {
    toolName: "Pressure Converter",
    paraData: ParaData.PRESSURE_CONVERTOR,
  },
  "/weight-convertor": {
    toolName: "Weight Converter",
    paraData: ParaData.WEIGHT_CONVERTOR,
  },
  "/volume-convertor": {
    toolName: "Volume Converter",
    paraData: ParaData.VOLUME_CONVERTOR,
  },
  "/volume-flow-rate-convertor": {
    toolName: "Volume Flow Rate Converter",
    paraData: ParaData.VOLUME_CONVERTOR,
  },
  "/time-convertor": {
    toolName: "Time Converter",
    paraData: ParaData.TIME_CONVERTOR,
  },
  "/frequency-convertor": {
    toolName: "Frequency Converter",
    paraData: ParaData.FREQUENCY_CONVERTOR,
  },
  "/speed-convertor": {
    toolName: "Speed Converter",
    paraData: ParaData.SPEED_CONVERTOR,
  },
  "/pace-convertor": {
    toolName: "Pace Converter",
    paraData: ParaData.PACE_CONVERTOR,
  },
  "/illuminance-convertor": {
    toolName: "Illuminance Converter",
    paraData: ParaData.ILLUMIMAMCE_CONVERTOR,
  },
  "/digital-convertor": {
    toolName: "Digital Converter",
    paraData: ParaData.DIGITAL_CONVERTOR,
  },
  "/angle-convertor": {
    toolName: "Angle Converter",
    paraData: ParaData.ANGLE_CONVERTOR,
  },
  "/energy-convertor": {
    toolName: "Energy Converter",
    paraData: ParaData.ENERGY_CONVERTOR,
  },
  "/Parts-per": {
    toolName: "Parts-per Converter",
    paraData: ParaData.PARTS_CONVERTOR,
  },
  "/voltage": {
    toolName: "Voltage Converter",
    paraData: ParaData.VOLTAGE_CONVERTOR,
  },
  "/apparent-power": {
    toolName: "Apparent Power Converter",
    paraData: ParaData.APPARENT_CONVERTOR,
  },
  "/reactive-power": {
    toolName: "Reactive Power Converter",
    paraData: ParaData.RELATIVE_CONVERTOR,
  },
  "/density": {
    toolName: "Density Converter",
    paraData: ParaData.DENSITY_CONVERTOR,
  },
  "/energy-extra-unit": {
    toolName: "Additional Energy Converter",
    paraData: ParaData.ENERY_EXTRA_CONVERTOR,
  },
  "/force": {
    toolName: "Force Converter",
    paraData: ParaData.FORCE_CONVERTOR,
  },
  "/power": {
    toolName: "Power Converter",
    paraData: ParaData.POWER_CONVERTOR,
  },
};
function DropDown({ Data }) {
  const pathName = usePathname();
  const currentRoute = unitConversionRouteConfig[pathName];
  const force = new Convert.Force();
  const energy = new Convert.Energy();
  const density = new Convert.Density();
  const power = new Convert.Power();

  const [selectFirst, setSelectFirst] = useState(
    Data?.UnitArray[0]?.split(" ")[0] || ""
  );
  const [selectSecond, setSelectSecond] = useState(
    Data?.UnitArray[0]?.split(" ")[0] || ""
  );
  const [first, setFirst] = useState(1);
  const [answer, setAnswer] = useState("");

  useEffect(() => {
    setFirst(1);
    setAnswer("");
    setSelectFirst(Data?.UnitArray[0]?.split(" ")[0] || "");
    setSelectSecond(Data?.UnitArray[0]?.split(" ")[0] || "");
  }, [Data?.navigate, Data?.UnitArray]);

  useEffect(() => {
    handleConversion();
  }, [first, selectFirst, selectSecond]);

  const handleConversion = () => {
    if (!Data) return;

    const lower = Data?.Name?.toLowerCase();
    let convertedValue;

    if (Data.dataType === "convert") {
      try {
        convertedValue = convert(first).from(selectFirst).to(selectSecond);
      } catch (error) {
        convertedValue = "Invalid Conversion";
      }
    } else {
      try {
        switch (Data.Name) {
          case "Force":
            convertedValue = force[selectFirst](first)[selectSecond]();
            break;
          case "Energy Extra Unit":
            convertedValue = energy[selectFirst](first)[selectSecond]();
            break;
          case "Density":
            convertedValue = density[selectFirst](first)[selectSecond]();
            break;
          case "Power":
            convertedValue = power[selectFirst](first)[selectSecond]();
            break;
          default:
            convertedValue = "Invalid Conversion";
        }
      } catch (error) {
        convertedValue = "Invalid Conversion";
      }
    }
    setAnswer(convertedValue || "N/A");
  };

  return (
    <>
      <div className="lenghth-box-design">
        <div className="two-col-grid">
          <div className="two-col-grid-items">
            <p>From:</p>
            <div className="all-input-design-alignment">
              <input
                type="number"
                name="firstInput"
                value={first}
                onChange={(e) => setFirst(Number(e.target.value))}
              />
              <select
                name="unit"
                value={selectFirst}
                onChange={(e) => setSelectFirst(e.target.value)}
              >
                {Data.UnitArray.map((item, index) => (
                  <option key={index} value={item.split(" ")[0]}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* To Section */}
          <div className="two-col-grid-items">
            <p>To:</p>
            <div className="all-input-design-alignment">
              <input type="text" name="resultInput" value={answer} disabled />
              <select
                name="unit"
                value={selectSecond}
                onChange={(e) => setSelectSecond(e.target.value)}
              >
                {Data.UnitArray.map((item, index) => (
                  <option key={index} value={item.split(" ")[0]}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
      {currentRoute && (
        <HowToUseText
          toolName={currentRoute.toolName}
          firstPata={currentRoute.paraData.firstPara}
          secondPara={currentRoute.paraData.secondPara}
          toolData={currentRoute.paraData.toolData}
          howToUse={currentRoute.paraData.howToUse}
          whyUse={currentRoute.paraData.whyUse}
          commonUseCases={currentRoute.paraData.commonUseCases}
          features={currentRoute.paraData.features}
          faq={currentRoute.paraData.faq}
          tips={currentRoute.paraData.tips}
          relatedTools={currentRoute.paraData.relatedTools}
        />
      )}
    </>
  );
}

export default DropDown;
